export interface VideoItem {
  id: string;
  title: string;
  cover: string;
  duration: string;
  views: string;
  platform: string;
  category: string;
  rating: string;
  tags: string[];
  url: string;
}

export interface VideoCategory {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const videoCategories: VideoCategory[] = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line', description: '浏览所有平台的优质影视内容' },
  { slug: 'xiangjiao', name: '香蕉视频', icon: 'ri-vidicon-line', description: '香蕉视频平台精选内容，实时更新热门影视' },
  { slug: 'hongtao', name: '红桃视频', icon: 'ri-heart-line', description: '红桃视频高清资源，丰富片库任你选择' },
  { slug: '91shipin', name: '91视频', icon: 'ri-fire-line', description: '91视频热门推荐，不缓冲流畅播放体验' },
  { slug: 'mitao', name: '蜜桃视频', icon: 'ri-emotion-laugh-line', description: '蜜桃视频独家内容，高清画质畅快观看' },
  { slug: 'yinghua', name: '樱花视频', icon: 'ri-flower-line', description: '樱花视频浪漫影视，唯美画风沉浸体验' },
  { slug: 'tangdou', name: '糖豆视频', icon: 'ri-cake-line', description: '糖豆视频趣味短片，轻松一刻乐享不停' },
  { slug: 'yingtao', name: '樱桃视频', icon: 'ri-red-packet-line', description: '樱桃视频精彩合集，每日更新看不停' },
];

export const mockVideos: VideoItem[] = [
  {
    id: 'v1', title: '最新热门大片《星际迷航：无尽探索》高清完整版', cover: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20with%20spaceship%20in%20deep%20space%2C%20dramatic%20lighting%2C%20epic%20composition%2C%20dark%20background%20with%20stars%2C%20movie%20poster%20style%2C%20high%20contrast%2C%20professional%20film%20poster%20design&width=800&height=450&seq=video-cover-01&orientation=landscape',
    duration: '128分钟', views: '128.5万', platform: '香蕉视频', category: 'xiangjiao',
    rating: '9.2', tags: ['科幻', '冒险', '动作'],
    url: '#'
  },
  {
    id: 'v2', title: '《甜蜜恋爱日记》第28集 - 浪漫都市爱情故事', cover: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20poster%20with%20couple%20walking%20in%20city%20at%20sunset%2C%20warm%20golden%20light%2C%20soft%20focus%2C%20emotional%20atmosphere%2C%20Korean%20drama%20style%20poster%2C%20dreamy%20aesthetic&width=800&height=450&seq=video-cover-02&orientation=landscape',
    duration: '45分钟', views: '89.3万', platform: '红桃视频', category: 'hongtao',
    rating: '8.9', tags: ['爱情', '都市', '韩剧'],
    url: '#'
  },
  {
    id: 'v3', title: '《爆笑喜剧人》第二季全集 - 笑到停不下来', cover: 'https://readdy.ai/api/search-image?query=Comedy%20show%20poster%20with%20colorful%20funny%20characters%20laughing%2C%20bright%20vibrant%20colors%2C%20playful%20design%2C%20entertainment%20show%20poster%2C%20cheerful%20atmosphere%2C%20bold%20typography&width=800&height=450&seq=video-cover-03&orientation=landscape',
    duration: '60分钟', views: '205.7万', platform: '91视频', category: '91shipin',
    rating: '9.5', tags: ['喜剧', '综艺', '搞笑'],
    url: '#'
  },
  {
    id: 'v4', title: '《午夜凶铃：重生》恐怖惊悚巨作未删减版', cover: 'https://readdy.ai/api/search-image?query=Horror%20movie%20poster%20with%20dark%20mysterious%20atmosphere%2C%20old%20abandoned%20house%20in%20fog%2C%20eerie%20lighting%2C%20thriller%20film%20poster%2C%20dark%20color%20palette%2C%20creepy%20aesthetic&width=800&height=450&seq=video-cover-04&orientation=landscape',
    duration: '105分钟', views: '156.2万', platform: '蜜桃视频', category: 'mitao',
    rating: '8.7', tags: ['恐怖', '惊悚', '悬疑'],
    url: '#'
  },
  {
    id: 'v5', title: '《舌尖上的中国风味》美食纪录片全12集', cover: 'https://readdy.ai/api/search-image?query=Food%20documentary%20poster%20with%20delicious%20Chinese%20cuisine%20dishes%2C%20warm%20steaming%20food%20photography%2C%20rich%20colors%2C%20cultural%20cooking%20scene%2C%20artistic%20food%20presentation%2C%20soft%20natural%20light&width=800&height=450&seq=video-cover-05&orientation=landscape',
    duration: '55分钟', views: '312.4万', platform: '樱花视频', category: 'yinghua',
    rating: '9.8', tags: ['美食', '纪录片', '文化'],
    url: '#'
  },
  {
    id: 'v6', title: '《武林外传新编》古装武侠喜剧热血回归', cover: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20drama%20poster%20with%20warriors%20in%20ancient%20Chinese%20costume%2C%20dynamic%20action%20pose%2C%20traditional%20Chinese%20architecture%20background%2C%20epic%20cinematic%20style%2C%20dramatic%20clouds&width=800&height=450&seq=video-cover-06&orientation=landscape',
    duration: '50分钟', views: '178.9万', platform: '糖豆视频', category: 'tangdou',
    rating: '9.1', tags: ['武侠', '古装', '喜剧'],
    url: '#'
  },
  {
    id: 'v7', title: '《极限挑战：荒野求生》真人秀冒险纪实', cover: 'https://readdy.ai/api/search-image?query=Adventure%20survival%20show%20poster%20with%20person%20in%20wild%20jungle%20landscape%2C%20dramatic%20nature%20scene%2C%20warm%20sunlight%20through%20trees%2C%20exploration%20theme%2C%20cinematic%20outdoor%20photography&width=800&height=450&seq=video-cover-07&orientation=landscape',
    duration: '90分钟', views: '234.6万', platform: '樱桃视频', category: 'yingtao',
    rating: '9.3', tags: ['真人秀', '冒险', '户外'],
    url: '#'
  },
  {
    id: 'v8', title: '《青春有你》偶像练习生终极舞台全纪录', cover: 'https://readdy.ai/api/search-image?query=Music%20talent%20show%20stage%20performance%20with%20colorful%20stage%20lights%2C%20young%20performers%20dancing%2C%20concert%20atmosphere%2C%20vibrant%20energy%2C%20entertainment%20show%20poster%2C%20dynamic%20composition&width=800&height=450&seq=video-cover-08&orientation=landscape',
    duration: '120分钟', views: '456.8万', platform: '香蕉视频', category: 'xiangjiao',
    rating: '9.6', tags: ['音乐', '选秀', '偶像'],
    url: '#'
  },
  {
    id: 'v9', title: '《速度与激情：终极狂飙》赛车动作巨制', cover: 'https://readdy.ai/api/search-image?query=Action%20racing%20movie%20poster%20with%20fast%20sports%20cars%20on%20city%20street%2C%20motion%20blur%20effect%2C%20neon%20lights%2C%20high%20speed%20chase%20scene%2C%20cinematic%20action%20film%20style%2C%20dynamic%20energy&width=800&height=450&seq=video-cover-09&orientation=landscape',
    duration: '142分钟', views: '389.1万', platform: '红桃视频', category: 'hongtao',
    rating: '9.0', tags: ['动作', '赛车', '犯罪'],
    url: '#'
  },
  {
    id: 'v10', title: '《动物王国》BBC级别自然纪录片震撼视觉', cover: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20with%20majestic%20wild%20animals%20in%20savanna%20landscape%2C%20golden%20sunset%20light%2C%20African%20wildlife%2C%20cinematic%20nature%20photography%2C%20warm%20earthy%20tones%2C%20breathtaking%20scenery&width=800&height=450&seq=video-cover-10&orientation=landscape',
    duration: '60分钟', views: '267.3万', platform: '91视频', category: '91shipin',
    rating: '9.7', tags: ['自然', '动物', '纪录片'],
    url: '#'
  },
  {
    id: 'v11', title: '《穿越时空的恋人》古装穿越甜宠剧热播中', cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20romance%20drama%20poster%20with%20couple%20in%20traditional%20hanfu%20costume%2C%20cherry%20blossom%20background%2C%20soft%20dreamy%20lighting%2C%20elegant%20Chinese%20aesthetic%2C%20romantic%20atmosphere&width=800&height=450&seq=video-cover-11&orientation=landscape',
    duration: '42分钟', views: '198.5万', platform: '蜜桃视频', category: 'mitao',
    rating: '8.8', tags: ['古装', '爱情', '穿越'],
    url: '#'
  },
  {
    id: 'v12', title: '《科技最前沿》深度解读AI人工智能革命', cover: 'https://readdy.ai/api/search-image?query=Futuristic%20technology%20documentary%20poster%20with%20digital%20circuit%20patterns%2C%20glowing%20data%20visualization%2C%20modern%20tech%20aesthetic%2C%20clean%20minimalist%20design%2C%20cool%20futuristic%20vibe%2C%20abstract%20tech%20background&width=800&height=450&seq=video-cover-12&orientation=landscape',
    duration: '35分钟', views: '92.7万', platform: '樱花视频', category: 'yinghua',
    rating: '9.4', tags: ['科技', 'AI', '科普'],
    url: '#'
  },
];